import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { Brand } from "models";

export type BrandFormPayload = Pick<
  Brand,
  | "id"
  | "name"
  | "country"
  | "vin_prefix"
  | "button_label"
  | "pon_brand_code"
  | "tablet_service_button_url"
  | "servicebox_wo"
  | "servicebox_vin"
  | "logo"
  | "color"
  | "is_active"
  | "servicebox_wo_2"
  | "servicebox_wo_2_name"
  | "brand_group_id"
>;

export const useCreateBrandMutation = () =>
  useTypedMutation<BrandFormPayload, number>({
    mutationFn: async payload => (await ApiInstance.post("/brands/create", payload, ENV.carBaseURL)).data.id,
    onSuccess: (payload, id) => {
      const previousBrands = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brands);
      const brandGroups = typedQueryClient.getQueryData(BrandsDashboardQueryKeys.brandGroups);
      const now = toISOString(new Date());
      const brand_group_name = brandGroups?.find(group => group.id === payload.brand_group_id)?.name;

      const createdBrand = { ...payload, id, brand_group_name, created_on: now, updated_on: now };

      typedQueryClient.setQueryData(BrandsDashboardQueryKeys.brands, [createdBrand, ...(previousBrands ?? [])]);
      if (!brandGroups) return;

      const groupIdx = brandGroups.findIndex(group => group.id === payload.brand_group_id);
      if (groupIdx === -1) return;

      const brandGroup = brandGroups[groupIdx];
      typedQueryClient.setQueryData(
        BrandsDashboardQueryKeys.brandGroups,
        brandGroups.with(groupIdx, { ...brandGroup, brands: [...(brandGroup.brands ?? []), createdBrand] })
      );
    }
  });
